/*
 * File: form-password.ts
 * File Created: 2024-09-13 09:29:08
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-10-14 09:28:11
 * Modified By: Val Liu
 * -----
 */

import { Component, Prop } from "vue-property-decorator";
import {
    IFormComponentAttr,
    IFormValidateResult,
    createRequiredValidator,
    createValidator,
} from "../../core/lib/core";
import { PropInnateSync } from "@root/core/vue-props";
import FormString from "../../elements/form-string/form-string";
import { UITag } from "@root/core/tags";
import {
    makeRequiredValidator,
    makeValidator,
} from "@root/core/decorators/make-validator";

const Securities = ["low", "medium"] as const;
export type SecurityType = (typeof Securities)[number];

@Component
@UITag.setDefault({
    uiAutofill: "password",
})
export default class FormPassword extends FormString {
    // the required length of password
    @Prop({ type: Number, default: 8 })
    length!: number;

    // the security level of password
    @Prop({
        type: String,
        default: "medium",
        validator: (value: string) => {
            const inc = Securities.includes(value as any);
            if (inc == false)
                console.error(`<${value}> is not a valid value for <security>.`);
            return inc;
        },
    })
    security!: SecurityType;

    /// private helpers
    // required validation for textarea
    @makeRequiredValidator({
        validator: (o) =>
            !(
                o.value === "" ||
                o.value == null ||
                (Array.isArray(o.value) && o.value.length == 0)
            ),
    })
    defaultRequired() {
        return undefined;
    }

    // validate the password rule
    @makeValidator({
        validator: function (this: FormPassword, o) {
            return regexSecurity[this.security](this.length).test(o.value);
        },
        message: function (this: FormPassword, o) {
            return this.$_("w_RequireValidPassword", { length: this.length });
        },
    })
    defaultValidator() {
        return undefined;
    }
}

const regexSecurity = {
    medium: (length: number) => {
        return new RegExp(
            `^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{${length},}$`,
        );
    },
    low: (length: number) => {
        return new RegExp(`^.{${length},}$`);
    },
};
